import { Pipe, PipeTransform } from '@angular/core';
import {
  FacilityType,
  prettyLocationRateTypes,
} from '@rivethealth/data/location';

@Pipe({ name: 'facility' })
export class FacilityPipe implements PipeTransform {
  transform(value: FacilityType): string {
    return prettyLocationRateTypes[value];
  }
}
